module.exports = __webpack_public_path__ + "media/packs/images/flags/NC-b0c826fb4e0611c0d5b22a710ce47012.png";